// StartPage - Landing page for the application

import * as React from "react";
import { useEffect} from "react";
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import QuizBanner from "../assets/images/QuizBanner.png";
import WikiBanner from "../assets/images/WikiBanner.png";
import MapBanner from "../assets/images/MapBanner.png";
import OmOss from "../assets/images/OmOss.png";
import solochskog from "../assets/images/solochskog.jpg";
import useGET from "../services/useGET";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";
import HeroSection from "../components/sections/HeroSection";
import ContentSection from "../components/sections/FeatureSection";

function Home() {
    const { data, isPending } = useGET(`${process.env.REACT_APP_API_URL}/api/users/${localStorage.getItem("email")}/can-order`);
    const canOrderValue = data?.can_order;

    const [cookies] = useCookies(["access"]);
    const history = useHistory();

    const isLoggedIn = Boolean(cookies.access);
    const handleLogout = () => {
        history.push("/signout");
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/visits`, {
            method: "POST",
            credentials: "include"
        })
        .catch(err => console.error(err));
    }, []);

    return (
        <div className="flex flex-col min-h-screen bg-offwhite font-body">
            {/* Navbar */}
            <Navbar />

            <main className="flex-grow">
                {/* Hero Section - Main header/welcome */}
                <HeroSection
                    title="Naturborgarmärket"
                    highlightText="Det naturliga äventyret"
                    description="Utforska Sveriges fantastiska naturområden, lär dig om den lokala floran och faunan, och testa dina kunskaper genom interaktiva quiz."
                    primaryButtonText="Kom igång"
                    primaryButtonLink="/omraden"
                    secondaryButtonText="Läs mer"
                    secondaryButtonLink="/om"
                    backgroundImage={solochskog}
                />

                {/* Feature 1 - Quiz */}
                <ContentSection
                    title="Gå direkt till quizet!"
                    highlightText="Testa din kunskap"
                    description="Testa din kunskap om Sveriges naturområden och lär dig mer om den fantastiska naturen runt omkring oss."
                    primaryButtonText="Starta Quiz"
                    primaryButtonLink="/quiz"
                    image={QuizBanner}
                    reverse={false}
                />

                {/* Feature 2 - Map */}
                <ContentSection
                    title="Välj naturområde"
                    highlightText="Utforska"
                    description="Gå vidare för att välja naturområde och upptäck alla de fantastiska platser som Sverige har att erbjuda."
                    primaryButtonText="Välj Område"
                    primaryButtonLink="/omraden"
                    image={MapBanner}
                    reverse={true}
                    backgroundColor="sage"
                />

                {/* Feature 3 - Species Info */}
                <ContentSection
                    title="Information om arter"
                    highlightText="Upptäck"
                    description="Här kan du läsa på om olika arter som finns i olika naturområden. Se bilder och beskrivningar av den svenska floran och faunan."
                    primaryButtonText="Utforska Arter"
                    primaryButtonLink="/arter"
                    image={WikiBanner}
                    reverse={false}
                />

                {/* Feature 4 - About */}
                <ContentSection
                    title="Om oss"
                    highlightText="Läs mer om Naturborgarmärket"
                    description="Läs mer om Naturborgarmärket, allemansrätten och se vilka som stödjer vår utveckling och arbete för naturen."
                    primaryButtonText="Om"
                    primaryButtonLink="/om"
                    secondaryButtonText="Allemansrätten"
                    secondaryButtonLink="/allemansratten"
                    image={OmOss}
                    reverse={true}
                    backgroundColor="sage"
                />
            </main>

            <Footer />
        </div>
    );
}

export default Home;
